import styles from './styles.module.scss';
import TournamentsPageContentInput from './Input';
import TournamentsPageContentCards from './Cards';

export default function TournamentsPageContent() {
  return (
    <div className={styles.container}>
      <TournamentsPageContentInput />
      <div className={styles.container__wrapper}>
        <TournamentsPageContentCards />
      </div>
    </div>
  );
}
